import { Trans } from "react-i18next";

import util from "utils/utils";

export default function IdeaSendEmail({ events, ownerIdea }) {
  return (
    <Trans
      i18nKey="notifications.ideaSendEmail"
      values={{
        name: util.getEventNames(events),
        idea: ownerIdea?.name || "Unknown",
      }}
    />
  );
}
